import { fetchApi } from './api';
import type { NewNoticeRequest, NoticeApp, NoticeList, NoticeRecord, NoticeTargetPage } from '../types/notices';

const BASE = '/notices';

/**
 * Client of the notices MAINTENANCE track (/api/v1/notices). The machine track
 * (`/notices/active`) is for the consumer apps' backends and is never called from here.
 */
export const noticesApi = {
    list: () => fetchApi<NoticeList>(BASE),
    apps: () => fetchApi<NoticeApp[]>(`${BASE}/apps`),
    pages: () => fetchApi<NoticeTargetPage[]>(`${BASE}/pages`),
    create: (body: NewNoticeRequest) =>
        fetchApi<NoticeRecord>(BASE, { method: 'POST', body: JSON.stringify(body) }),
    expire: (id: number) =>
        fetchApi<NoticeRecord>(`${BASE}/${id}/expire`, { method: 'POST' }),
};
